/*
<summary>
   This file is used to provide initial values or state to the Process Module Observables.
   Developer:Urvashi, Created Date: 23-December-2024
</summary>
*/
import { IPortalListVM } from '../../models/response/IAimsResponse';

const initialPortalState: IPortalListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  AIMSs: [],
  AIMSDetails: {
    RegularModeTemplateId: '-1',
    DeadlineCrossTemplateId: '-1',
    NearDeadlineTemplateId: '-1',
    PatternForMissingPartTemplateId: '-1',

    DeadlineCrossProTemplateId: '-1',
    NearDeadlineProTemplateId: '-1',
    PatternForMissingPartProTemplateId: '-1',
    RegularModeProTemplateId: '-1',

    NearDeadLineDate: 0,
    StationCode: '',
    Url: '',
    TenantId: -1,
  },
};

export default initialPortalState;
